import { graphql } from "react-relay";

export const UpsertAnthropicIntegrationMutation = graphql`
  mutation UpsertAnthropicIntegrationMutation(
    $input: UpsertAnthropicIntegrationInput!
    $connections: [ID!]!
  ) {
    upsertAnthropicIntegration(input: $input) {
      anthropicIntegration
        @appendNode(
          connections: $connections
          edgeTypeName: "AnthropicIntegrationEdge"
        ) {
        configured
        id
        orgId
        orgName
      }
      problems {
        __typename
        message
      }
    }
  }
`;
